import { Component, inject, OnInit } from '@angular/core';
import { CodaltComponent } from 'src/app/codalt.component';
import { PeriodService } from 'src/app/services/period.service';

@Component({
    selector: 'app-settlement-send-all',
    templateUrl: './settlement-send-all.component.html',
    styleUrls: ['./settlement-send-all.component.scss'],
    standalone: false,
})
export class SettlementSendAllComponent extends CodaltComponent implements OnInit {
    private readonly periodService = inject(PeriodService);

    endDate: Date;

    constructor() {
        super();
    }

    ngOnInit(): void {
        const { beginDate } = this.periodService.getPeriodDateInfo(this.periodService.getPeriodOfDate(new Date()));

        // Laatste moment van de afgelopen periode.
        this.endDate = new Date(beginDate.getTime() - 1);
    }
}
